export enum EstablishmentTypeWord {
  hotel = 'hotel',
  room = 'room',
  stayDates = 'stayDates',
  contler = 'contler',
}

export interface WordReplacement {
  key: EstablishmentTypeWord;
  value: string;
}
export interface EstablishmentType {
  key?: string;
  name: string;
  wordReplacements: WordReplacement[];
}
